<section class="mat-typography mat-body">
  <ng-container>

    @if (!hidePreloginBool && isLoggedIn == false) {
      <app-pre-login-view [registrationUrl]="registrationUrl"
        [producerLandingPageUrl]="producerLandingPageUrl" [memberLandingPageUrl]="memberLandingPageUrl"
        [consumerLandingPageUrl]="consumerLandingPageUrl"
        [forgotPasswordUrl]="forgotPasswordUrl">
      </app-pre-login-view>
    }
    @if (isLoggedIn == true) {
      <app-post-login-view [myAccountUrl]="myAccountUrl"
        [consumerLogoutRedirectUrl]="consumerLogoutRedirectUrl" [producerLogoutRedirectUrl]="producerLogoutRedirectUrl">
      </app-post-login-view>
    }

  </ng-container>
</section>